import { RotateCcwIcon } from "lucide-react";

import { Button } from "@ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui/tooltip";

export const SadieSimulatorResetButton = ({
  disabled,
  onClick,
}: {
  disabled: boolean;
  onClick: () => void;
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button
        aria-label="Reset to default"
        className="h-7 w-7 text-slate-500"
        disabled={disabled}
        onClick={onClick}
        size="icon"
        variant="ghost"
      >
        <RotateCcwIcon className="h-3.5 w-3.5" />
      </Button>
    </TooltipTrigger>
    <TooltipContent>Reset to default</TooltipContent>
  </Tooltip>
);
